let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ajouS")).then(() => parcelRequire('2PadD'));